export default "__VITE_ASSET__fda1e6c8__"